/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_TitleInputs */

const en_mk_ctrl_title = /** @type {(inputs: Mk_Ctrl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See where your AI budget goes — before the bill arrives`)
};

const id_mk_ctrl_title = /** @type {(inputs: Mk_Ctrl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat ke mana anggaran AI-mu pergi — sebelum tagihan datang`)
};

/**
* | output |
* | --- |
* | "See where your AI budget goes — before the bill arrives" |
*
* @param {Mk_Ctrl_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_title = /** @type {((inputs?: Mk_Ctrl_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_title(inputs)
	return en_mk_ctrl_title(inputs)
});